var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useContext, useEffect } from 'react';
import isNumber from 'lodash/isNumber';
import camelCase from 'lodash/camelCase';
import classNames from 'classnames';
import { updateCSS } from 'rc-util/lib/Dom/dynamicCSS';
import { ICON_PREFIX, DEFAULT_WIDTH, ICON_STYLES } from './constants';
import IconContext from './components/IconContext';
export var getIconSettledProps = function (props) {
    var _a, _b;
    var name = props.name, _c = props.width, width = _c === void 0 ? DEFAULT_WIDTH : _c, height = props.height, className = props.className, _d = props.fill, fill = _d === void 0 ? 'currentColor' : _d, rotate = props.rotate, animation = props.animation, prefixCls = props.prefixCls, restProps = __rest(props, ["name", "width", "height", "className", "fill", "rotate", "animation", "prefixCls"]);
    var spanClassName = classNames(prefixCls, (_a = {}, _a["".concat(prefixCls, "-").concat(name)] = !!name, _a), (_b = {}, _b["".concat(prefixCls, "-animation-").concat(animation)] = !!animation, _b), className);
    var svgStyle = isNumber(rotate) ? { transform: "rotate(".concat(rotate, "deg)") } : {};
    return {
        spanProps: __assign({ className: spanClassName }, restProps),
        svgProps: {
            width: width,
            height: height,
            style: svgStyle,
            fill: fill
        }
    };
};
export var useInsertStyles = function (styleStr) {
    if (styleStr === void 0) { styleStr = ICON_STYLES; }
    var prefixCls = useContext(IconContext).prefixCls;
    var mergedStyleStr = styleStr;
    if (prefixCls) {
        var replaceReg = new RegExp(ICON_PREFIX, 'g');
        mergedStyleStr = mergedStyleStr.replace(replaceReg, prefixCls);
    }
    useEffect(function () {
        updateCSS(mergedStyleStr, prefixCls || 'acud-icon', {
            prepend: true
        });
    }, [prefixCls, mergedStyleStr]);
};
export var normalizeAttrs = function (attrs) {
    if (attrs === void 0) { attrs = {}; }
    return Object.keys(attrs).reduce(function (acc, key) {
        var val = attrs[key];
        var camelKey = camelCase(key);
        acc[camelKey] = val;
        return acc;
    }, {});
};
